import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAction, currentLanguage = 'fr' }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'add-agency',
      label: { fr: 'Gérer les agences', ar: 'إدارة الوكالات' },
      icon: 'Users',
      variant: 'default',
      route: '/agency-management'
    },
    {
      id: 'manage-plans',
      label: { fr: 'Gérer les plans', ar: 'إدارة الخطط' },
      icon: 'Package',
      variant: 'outline'
    },
    {
      id: 'system-settings',
      label: { fr: 'Paramètres système', ar: 'إعدادات النظام' },
      icon: 'Settings',
      variant: 'outline'
    },
    {
      id: 'reports',
      label: { fr: 'Rapports', ar: 'التقارير' },
      icon: 'FileText',
      variant: 'outline'
    }
  ];

  const handleClick = (action) => {
    if (action?.route) {
      navigate(action?.route);
    } else {
      onAction?.(action?.id);
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Actions rapides</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            fullWidth
            onClick={() => handleClick(action)}
          >
            {action?.label?.[currentLanguage]}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;